/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { sqrtDependencies } from './dependenciesSqrt.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { varianceDependencies } from './dependenciesVariance.generated.js';
import { createStdTransform } from '../../factoriesAny.js';
export var stdTransformDependencies = {
  sqrtDependencies,
  typedDependencies,
  varianceDependencies,
  createStdTransform
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesStdTransform.generated.js
// module id = null
// module chunks = 